import { market } from "../market/zh";
import { invite } from '../invite/zh';
import { property } from '../property/zh';
import {advertise} from '../advertise/zh';
import {login, download} from '../login/zh';
import {trading} from '../trading1/zh';
import { contest } from "../contest/zh";
import { merchandiser, common, tableList, dialog, codeInfo, hyy as contractHyy, placeOrder, codelist, panKou } from "../merchandiser/zh";
import { games } from '../games/zh';
import { taskCenter } from "../task/zh";
import { ieo } from "../ieo/zh";
import { earn } from "../earn/zh";
import { apis } from "../api/zh";
import { tradingContest } from "../tradingContest/zh";
import { agent } from "../agent/zh";
import { live } from "../live/zh";
import { hongbao } from "../hongbao/zh";


const time = {
  r: "日",
  s: "时",
  f: "分",
  m: "秒",
};
// 状态
const state = {
  preheatIng: "预热中",
  purchaseIng: "抢购中",
  over: "已结束",
  finish: "已完成",
  noData: "暂无数据",
  process: "助力中",
  sellout: "已抢完",
};
// 模板文字
const text = {
  now: "正在进行",
  start: "距离本轮开始",
  end: "距离本轮结束",
  jd: "本轮进度",
  complete: "已完成",
  limited: "限时折扣价",

  finish: "已完成",
  subscribing: "申购中",
  subscribeNow: "立即申购",
  buyStart: "距离申购开始",
  buyEnd: "距离申购结束",
  projectAmount: "项目份数",
  quota: "每份额度",
  buyPrice: "申购价格",
  buyLimit: "申购限额",
  buyAmount: "申购数量",
  buyPos: "申购币种持仓",
  startDate: "开始时间",
  endDate: "结束时间",
  projectSuppot: "项目支持",
  websit: "项目官网",
  projectDetail: "项目详情",
  cycle: "申购周期",
  all: "全部",
  step1: "预热",
  step2: "申购",
  step3: "摇号",
  step4: "公布结果",
  subOrder: "申购订单",
  myOrder: "中签订单",
  proCoin: "项目币种",
  buyCoin: "申购币种",
  orderDate: "订单时间",
  issuanceQuota: "发放额度",
  dealAmount: "成交数量",
  dealPrice: "成交金额",
  status: "状态",
  ctrl: "操作",
  checkOrder: "查看签号",
  subNum: "申购签号",
  myNum: "中签签号",
  status0: "已申购",
  status1: "待扣款",
  status2: "已完成",
  conditionTerm1: "申购开始时间前*日，",
  conditionTerm2: "交易对*",
  conditionTerm3: "全部交易对",
  conditionTerm4: "交易在币币交易的总金额（USDT）累计值每达到*，可申购1份",
  noData: "暂无数据",
  qgsc: "抢购锁仓",
  yhsg: "摇号申购",
  sgsb: "申购失败",

  supply: "本轮额度",
  rate: "兑换比例",
  ceiling: "助力上限",
  xmwc: "项目已完成",
  xmze: "项目总额",
  zkjj: "折扣均价",
  cyrs: "参与人数",
  round: "第[*]轮",
  r: "人",
  cgqg: "成功抢购",
  cgzl: "成功助力",
  xmed: "项目额度",
  kszl: "开始助力时间",
  ksqg: "开始抢购时间",
  jsqg: "结束抢购时间",
  jszl: "结束助力时间",
  hdgz: "活动规则",
  xmjs: "项目介绍",
  tcqr: "您退出确认支付后，可能将会失去本次抢购活动的机会。 请谨慎操作！",
  jxtc: "继续退出",
  fhzf: "返回支付",
  qgrsd: "当前抢购人数较多，努力抢购中，请耐心等待！",
  zltcqr: "您退出确认支付后，可能将会失去本次助力活动的机会。 请谨慎操作！",
  zlqgrsd: "当前助力人数较多，请耐心等待！",
  wxts: "温馨提示：请尽快确认支付，[*]分钟内未完成支付将会支付超时且关闭窗口。",
};

const seckill = {
  sgno: "您尚未满足申购条件",
  srjymm: "请输入交易密码",
  ljzf: "立即支付",
};
const apply = {
  condition: "申购条件",
  apply: "立即申购",
  buyPrice: "申购价格",
  buyAmount: "申购数量",
  applyAmount: "申购金额",
  forget: "忘记交易密码?",
  noAmount: "请输入申购数量",
  buyLimit: "申购限额",
  success: "申购成功！",
  paySummary:"温馨提示：请尽快确认支付，<b>3分钟内</b>未完成支付，将会支付 超时且关闭窗口",
  appFull: "申购数量过大",
  seckill_async_fail_13: "两次申购的时间间隔为{}分钟",
};

const seckillRes = {
  seckill_async_3: "支付中，请稍等！",
  seckill_async_5: "取消成功",
  seckill_async_fail_1: "抱歉！请刷新页面，重新尝试！",
  seckill_async_fail_2: "抱歉！请刷新页面，重新尝试！",
  seckill_async_fail_3: "抱歉！请刷新页面，重新尝试！",
  seckill_async_fail_4: "抱歉！额度已抢完!",
  seckill_async_fail_5: "抱歉！支付已超时，请重新尝试！",
  seckill_async_fail_6: "支付密码输入错误，请重新输入！",
  seckill_async_fail_7: "交易密码错误次数超限,请稍后再试！",
  seckill_async_fail_8: "抱歉！支付已超时,请重新尝试！",
  seckill_async_fail_9: "抱歉！额度已抢完，期待您下次成功！",
  seckill_async_fail_10: "当前抢购人数较多，请稍候再试！",
  seckill_async_fail_11: "行为验证校验失败！",
};
const header = {
  zcgl: "资产管理",
  zczh: "资产账户",
  bbzh: "币币账户",
  fbzh: "买币账户",
  bdbzh: "币贷宝账户",
  wdgl: "委单管理",
  lswt: "历史委托",
  qbhz: "钱包互转",
  yhzx: "用户中心",
  wdhb: "我的红包",
  openOrder: "当前委托",
  dealStats: "成交统计",
  totalAsset: "总资产估值",
  cz: "合约账户",
  gmcnyt: "购买CNYT",
  yqfy: "邀请返佣",
  hbthhr: "HBT合伙人",
  tczh: "退出账户",
  moreNew: "更多公告",
  gfgg: "官方公告",
  zxxw: "最新新闻",
  ckgd: "查看更多",
  bbdd: "币币订单",
  bbwhydd: "币本位永续合约订单",
  etfdd: "ETF订单",
  fbdd: "法币订单",
};

const recommend = {
  vol24h: "24H量",
  jyd: "交易对",
  jydlx: "交易对类型",
  zxj: "最新价",
  change24: "24H涨跌",
  line24: "价格趋势（3日）",
};

const hyy = {
  ty: "同意",
  bkt: "不开通",
  wqdkt: "我确定开通",
  kt12: "1.	您在参与之前务必详尽地了解数字货币合约交易的基本知识和相关风险以及参与衍生品交易所有关的业务规则等。",
  kt13: "2.	本风险提示书上述风险事项仅为列举性质，未能详尽的列明有关数字资产衍生品交易的所有风险因素，投资者参与数字资产衍生品交易投资前，还应该认真对其它可能存在风险因素有所了解和掌握。",
  kt14: "3.	我们诚挚的希望和建议投资者，从风险承受能力等自身实际情况出发，审慎的决定是否参与此合约交易，合理地配置自己的数字资产。",
  kt0: "亲爱的用户：",
  kt1: "您尚未开通合约账户及合约交易权限，请您仔细阅读以下内容以后再决定是否开通：",
  kt2: "一、	您在合约市场进行交易，假如市场价格走势对您不利导致您的仓位保证金不足时，BiKing永续合约会按照系统约定对您的仓位进行强平委托并披露强平明细。",
  kt3: "二、	您必须认真阅读并遵守BiKing永续合约的业务规则，了解合约的机制和运行原理，了解市场的各种风险。",
  kt4: "四、	BiKing永续合约接入的是合约交易系统，用户仓位的盈亏随合约行情的波动而变化，当亏损较大时，亦会在合约交易系统中发生爆仓。请用户您及时根据合约行情自行决定自己的交易行为，自负盈亏，据此，BiKing不承担任何推定或者既定的保证责任。",
  kt5: "五、 请用户自觉遵守平台的相关规则，自觉遵守相关国家地区的法律法规，若用户合约账户因违规操作异常，账户将会被冻结，用户将无法操作，平台亦无法为用户执行平仓，若由此造成损失或爆仓，平台将不会为此承担任何责任 。",
  kt6: "六、	数字资产衍生品交易可能面临一定法域内的政策监管风险，您在交易之前需在了解交易地域的政策监管背景的前提下审慎做出判断。由于相关国家及地区法律、法规、政策的变化、合约交易所交易规则的修改、紧急措施的出台等原因，BiKing会提前披露声明，您持有的未平仓合约可能无法继续持有，但保证金和盈利的结余仍会兑现。",
  kt7: "七、	由于非平台方所能控制的原因，例如：地震、水灾、火灾等不可抗力因素或者计算机系统、通讯系统故障等，可能造成您的指令无法成交或者无法全部成交，由此导致的损失可能会由您自己承担。",
  kt8: "八、	 “套期保值”交易同投机交易一样，同样面临价格波动引起的风险。",
  kta9: "九、	如果您没有进行实名认证或者未绑定Google验证，或者将账号借给非本人操作，将可能会影响您的合约保证金的安全性。",
  kta10:"三、 在某些极端的市场情况下，您可能会难以或无法将持有的未平仓合约平仓。例如，当你的盈利在整个合约市场中有效杠杆PnL中排位第一，且对手盘在保险基金不足以垫付其穿仓损失的情况下。",
  kt9: "我已仔细阅读，并愿意承担风险",
  kt10: "开通合约账号及合约交易权限",
  zjhz: "资金划转",
  ljhz: "立即划转",
  qx: "取消划转",
  khz: "可划转",
  qxz: "请选择",
  bz: "币种",
  c: "从",
  zz: "转至",
  sl: "数量",
  qb: "全部",
  ktcg: "开通成功",
  ktsb: "开通失败",
  hzcg: "划转成功",
  hzsb: "划转失败",
  wyyd: "", //未勾选已经阅读提示文案
  tc: "退出",
  warning1: "请选择币种",
  warning2: "转出账户不能为空",
  warning3: "转入账户不能为空",
  warning4: "请输入不大于可转数量的数字",
  warning5: "最大保留4位小数",
  gb: "关闭",
  openSuccess: "您已开通合约交易",
  openSuccessTip: "请划转资金到合约账户",
  wsmyz: "您尚未完成实名认证",
  hdnm: "完成实名认证并累计净划入[*]USDT可获得[**]USDT泥码",
  nmjl: "泥码记录",
  nmhzjl: "泥码获赠记录",
  gxn: "恭喜您!",
  qwjy: "前往交易",
  yfrndhyzh: "已放入您的合约账户",
  nzxy: "您只需再向合约账户划转[*]USDT 便能获得[**]USDT泥码",
  nmssm: "泥码是什么",
  nm: "泥码",
  nxhyzh: "您向合约账户",
  text1: "向合约账户累计 净划转 [*]USDT以上,获得",
  text2: "您只需再向合约账户划转[*]USDT",
  text3: "便能获得[*]USDT泥码",
  text4: "余额",
  text5: "您向合约账户累计净划转[*]USDT以上，已获得",
  not_get_nm: "抱歉，泥码活动已发放结束，本次划转未能获得泥码",
  yijie: "1、一阶",
  erjie: "2、二阶",
  ljjhr: "累计净划入",
  khd: "可获得",
  hysnm: "合约送泥码",
  bbgg: "永续合约 百倍杠杆",
  hdsj: "活动时间：",
  hdxq: "活动详情",
  ljhd: "立即领取",
  xdxd: "先到先得",
  ylnnz: "赢了你拿走，输了算我的",
};

const Verification = {
  channel: "官方验证通道",
  verify: "请输入需要验证的信息",
  notes: "安全提示",
  notes1:"1. 所有与BiKing相关的邮箱、微信号、QQ号、域名及媒体号均可在此进行验证。",
  notes2: "2. 社交媒体账号（微博、推特等）仅支持名称查询，需要区分大小写。",
  notes3: "3. 如对验证结果有疑问，可在官网或者APP内联系官方客服进行再次确认。",
  error: "验证失败",
  error1: "您查询的信息",
  error2: "不是官方认证的渠道，请注意保护资产安全，谨防私人信息泄露。",
  errorNote: "注意事项",
  errorNote1:"1. 目前官方验证渠道仅支持验证邮箱、官方微信号、QQ号、域名及社交媒体账号 ",
  errorNote2: "2. 微信等聊天工具仅支持账号（非昵称）进行查询 ",
  errorNote3: "3. 社交媒体账号仅支持名称查询，需要区分大小写",
  success: "验证成功",
  success1: "您查询的信息：",
  success2: "是BiKing官方认证的",
  success3: "，若该号码/账号出现在其他渠道则不可信任，请注意资产安全。",
  more: "查看更多",
  know: "我已知晓",
  weChat: "微信",
  name: "域名",
  webo: "微博",
  twitter: "推特",
  email: "邮箱",
  contact: "联系客服",
  bannerTip:"为防止不法分子借用BiKing名义进行诈骗，您可通过此页面确认联系 您的电话、微信等是否为BiKing官方渠道。",
};
const index = {
  downloadIos: 'AppStore下载',
  downloadAndroid: '安卓下载',
  downloadGoogle: 'Google Play下载'
};

const indexPage = {
  gfgg: "官方公告",
  zxxw: "最新新闻",
  ckgd: "查看更多",
};

const NAVS = {
  xh: '现货',
  hhjy: 'Swap交易',
  ty: '体育',
  hqsj: '行情',
  game: '游戏',
  fx: '发现',
  sj: '数据',
  fb: "买币",
  bb: "现货交易",
  jr: "金融",
  jyds: "交易大赛",
  hbhd: "红包活动",
  gg: "杠杆交易",
  yxhy: "永续合约",
  eft: "ETF交易",
  flhd: "福利活动",
  flzx: "福利中心",
  fast: "快速交易",
  spec: "专业交易",
  login: "登录",
  rig: "注册",
  downapp: "下载BiKing APP",
  downappsum: "流畅体验 秒速充提",
  zichan: "资产",
  order: "订单",
  qbhz: "钱包互转",
  lang: "语言",
  calc: "计价方式",

  mb: "买币",
  hq: "市场",
  hy: "合约",
  jy: "交易",
  lc: "赚币",
  fs: "Fansup",
  xy: "学院",
  byxy: "BiKing学院",
  byyx: "BiKing研选",
  coins: "COINS积分",
  gd: "更多",
  yqhy: "邀请好友",
  rwzx: "任务中心",
  bbms: "用USDT购买比特币等数字资产",
  ggms: "平台出借数字资产，放大收益与风险",
  yxms: "百倍杠杆支持，操作便捷多样",
  etfms: "放大收益，无爆仓风险",
  pool: "共享矿池",
  czzn: '操作指南',
  gywm: '关于我们',
  zhxx: '账户信息',
  gd:"跟单合约",
  yxhy: "永续合约",
  zjhy: "赠金合约",
  product: "产品",
};

const FOOTERS = {
  zxkf: "在线客服",
  fawu: "法律建议",

  us: "我们",
  product: "产品",
  service: "服务",
  college: "学习",

  aboutUs: "关于我们",
  rateSum: "费率说明",
  notices: "公告中心",
  helps: "帮助中心",
  verific: "官方验证通道",
  contact: "联系我们",

  fabi: "买币",
  bibi: "币币交易",
  ganggan: "杠杆交易",
  swiper: "永续合约",
  etf: "ETF交易",
  licai: "赚币",

  apis: "API支持",
  apisNew: "API支持",
  addCoin: "上币申请",
  vips: "VIP权益",
  downapp: "APP下载",
  files: "法律文件",

  newuser: "BiKing新手营",
  swiperSchool: "合约学院",
  assistant: "学习助手",
  digitalintroduction: "数字资产介绍",

  watchword: "世界级的绿色交易平台",
  meiyitian: "每一天，让财富发生",
  chat: "聊天室",
  shequncn: "Telegram中文社群",
  shequnen: "Telegram英文社群",
  shequnkr: "Telegram韩文社群",
};

const SIDEBAR = {
  newuser: "新手",
  guide: "引导",
  bbsq: "币币社群",
  hysq: "合约社群",
  gd: "固定",
  sq: "收起",
};

const banner = {
  wzwh: '使用Biking 网站和/或维护您的账户，即表示您同意我们更新的',
  sytk: '使用条款',
  yszc: '隐私政策',
  hh: '和',
  cookie: 'CookIe政策',
  djgb: '单击“X”即表示您承认您已阅读并同意上述条款和政策。',

  title: '多元化游戏及数字货币交易平台',
  marketTitle: '数字货币交易 我们是专业的',
  marketSubTitle: '致力于为用户提供更为安全 稳定的加密资产衍生品交易服务',
  pathTitle: '您数字货币之旅的得力助手',
  pathSubTitle: '千万用户的选择，你值得信赖的平台',
  jylz: '3000亿美元',
  jyl: '72小时交易量',
  sxs: '加密货币已上线',
  zcyh: '注册用户',
  zdjy: '最低交易手续费',
  connectTitle: '为什么选择我们',
  connectSubTitle: 'BiKing助您创造、增值及保管财富',
  advantageText1: '顶级性能 · 极速交易',
  advantageSubText1: '伦敦证券交易所技术驱动，超低延迟，极速撮合',
  advantageText2: '资产保障 · 极致安全',
  advantageSubText2: '币王符合CCSS标准，保障资产及数据安全',
  advantageText3: '高流动 · 低点差',
  advantageSubText3: '币王合约杠杆交易，超高效率，最小滑点',
  advantageText4: '全天候服务',
  advantageSubText4: '保证系统正常运行，提供全天候客户服务',
  advantageText5: '便捷易用',
  advantageSubText5: '提供多种订单系统及交易工具，风险可控',
  advantageText6: '随时随地 · 安心交易',
  advantageSubText6: '币王 平台提供网页版，手机应用程式，API及FIX连接',
  netWorkTitle: '26个国家 120万用户的共同选择',
  netWorkSubTitle: '致力于为用户提供更为安全、稳定的加密资产衍生品交易服务',
  smxz: '扫码下载',
  fxbzj: '风险保证金',
  fkbz: '让每一笔交易都有全方位的资金风控保障',
  question1: '1.币王交易所介绍',
  questionContent1: '币王交易所是一家全球领先的新加坡数字资产交易平台，持有美国/加拿大MSB双牌照，提供多种数字资产的交易、存储、管理等服务。',
  question2: '2.币王交易所提供哪些产品？',
  questionContent2: '币王交易所提供以下几种产品：永续合约 ——优深度，秒撮合;现货交易 ——0手续，快速成交;跟单社区 ——资深交易员，稳定策略单;赠金交易 ——特有模式，福利不断;Web钱包 ——去中心化一站式服务',
  question3: '3.如何注册币王交易所？',
  questionContent3: '您可以在币王交易所官网或币王APP进行注册。点击注册 ，完成注册流程即可使用币王交易所进行数字货币投资理财。',
  question4: '4.如何通过币王交易所购买数字货币？',
  questionContent4: '币王交易所快捷买币支持多种支付方式与多种法币，为全球用户提供了更多的选择和便利，无论用户来自哪个国家或地区，都可以方便地使用本地货币购买数字货币。',
  question5: '5.如何进行数字资产交易？',
  questionContent5: '您可以在币王交易所选择需要交易的数字资产，进入交易页面后，选择购买或出售，输入交易数量和价格，确认交易即可。并且币王交易所支持多种数字资产交易，包括比特币、以太坊、莱特币、瑞波币等。',
  question6: '6.币王交易所如何保障用户资产安全？',
  questionContent6: '币王交易所采用多层加密技术保障用户信息和资产安全，并且采用冷热钱包分离的存储方式，确保用户资产安全。',

  investor: '300W加密货币投资者信赖',
  transaction: '在BIKing投资、交易及成长',
  hypt: '全球安全领先的数字资产 合约交易平台',
  yjpc: '一键即可开平仓',
  jscrj: '极速出入金，60S开启交易 真正实现零滑点交易',
  zcpt: '注册交易即领USDT',
  email: '邮箱地址',
  phone: '手机号码',
  zc: '注册',
  yhjaqbz: '银行级安全保障',
  lhdmch: '0滑点秒撮合',
  qthkf: '7*24小时客服',
  rmjmhb: '热门加密货币',
  jrsq: '加入Biking社区',
  hqzxhd: '获取最新的Biking活动资讯和在线支持',
}
const navCard = {
  join: 'Join BiKing',
  hzdl: 'BiKing币王合作代理签约期待您的加入',
  jmrx: '代理加盟热线：183283232998',
  contract: 'Contract online',
  yxhy: '快捷合约币王双合约惊喜上线',
  jylh: '交易更灵活 收益更丰富',
  usa: 'USA AND CANADA MSB',
  zmjys: '海外知名交易所BIKing币王荣获多国合规拍照',
  fxpf: '风险即赔付 安全可信赖',
  srhy: '币王首入合约送30%真金',
  hdsj: '活动时间：2022年11月01日0点至2022年12月01日0点'
}

const choice = {
  gjyh: '26个国家 120万用户的共同选择',
  jyfu: '致力于为用户提供更为安全、稳定的加密资产衍生品交易服务',
  wsmxzwm: '为什么选择我们',
  jsty: '极速体验',
  jmsj: '交易界面设计结合平台多年用户运营经验，流程清晰，操作便捷，更有微秒级的核心内存撮合技术，为用户提供更为方便舒适的交易体验。',
  kfx: '抗风险价格机制',
  pthybz: '平台合约币种价格采用多源指数集成式算法，具有强力的风险控制能力，有效规避各种极端行情下，市场波动产生的用户风险和损失。',
  zjaqbz: '资金安全保证',
  zjdt: '所有资金动态均有多重离线签名完成，保证微秒级判断，深度冷储存资产，全面护航用户的资金安全，为每一位用户提供100%的银行级安全风控。',
  jszc: '顶级技术支持',
  ptjstd: '平台技术团队由一批顶级的区块链技术专家组成，保障用户的极致体验，为平台的发展和运营提供强大的技术支持。',
  jcjz: '阶梯式减仓机制',
  hqbh: '根据市场行情变化，合理触发用户交易风控机制，24小时为用户的财产保驾护航。',
  kf: '24小时客服',
  ptkf: '平台采用24小时客服轮班制，认真对待每一个用户所遇到的问题。'

}

const plat = {
  ptgn: '平台功能',
  zjms: '赠金模式',
  zjjs: '赠金模式为币王团队为全网合约用户首发推出的特色合约新玩法，赠金模式的操作流程与实盘合约一致，开仓所获得的盈利部分可划转至合约账户，用于继续开仓或直接提现，获得途径包括：手续费实时返还，活动空投，完成任务等。',
  zcms: '全仓模式',
  zcjs: '全仓模式下，所有仓位的保证金及浮动盈亏互联共通，且包括开仓保证金在内的所有账户资产做为浮动保证金。全仓模式下具有较强的风险控制能力，但同样当行情波动剧烈时，容易超过亏损预期。',
  zucms: '逐仓模式',
  zucjs: '逐仓模式下，每笔订单相互独立，根据各仓位的开仓价格独立计算盈利及亏损。单笔订单的本金（或称为保证金）亏损至最大止损点后，将会被强制平仓。盈利至最大止盈点时，自动平仓。当逐仓模式下有持仓单或计划单时，将无法切换逐仓模式开仓。',
  gdgn: '跟单功能',
  gdjs: '启动跟单功能后，跟单交易员的所有开仓平仓行为都将同步执行，仅在账户余额不足或超过持仓上限的情况下无法完成同步。若无手动取消跟单功能，跟单功能将持续开启。',
  bfpc: '部分平仓',
  bfjs: '当持有一定数量的多仓或空仓时，可根据行情变化和盈亏情况，自由选择的平仓金额，与此同时，持仓单的盈亏金额也将根据平仓金额与保证金总额的比例，进行等比例结算，平仓后浮盈不变。',
  fxkc: '反向开仓',
  fxjs: '系统会以市场最优价格自动帮您平掉当前所选中的持有仓位，并以市场最优价格开出反方向同等持仓数量的仓位，以避免错过反转行情或反转行情来临时来不及开仓的情况。',
  zjbzj: '追加保证金',
  zjbzjjs: '当持有一定数量的多仓或空仓时，可在当前持仓的各项参数的前提下追加保证金，加仓后仓位系数将根据开仓和加保证金时各自的仓位参数进行分权重公式计算。'
}

const risk = {
  fxbzj: '风险保证金',
  fxbz: '让每一笔交易都有全方位的资金风控保障'
}

const license = {
  license: '币王荣获MSB金融牌照',
  hgyy: '合规运营，全球布局',
  login: '登录',
  download: '扫码下载币王',
  support: '支持',
  jsjy: '随时交易 极速成交',
  ljxz: '立即下载BiKing App'
}

const footer = {
  yhyh: '对用户最友好的',
  jypt: '合约交易平台',
  yhzc: '用户支持',
  flsm: '费率说明',
  ggzx: '公告中心',
  yhxz: '用户须知',
  tksm: '条款说明',
  fxzs: '风险提示',
  xylb: '协议列表',
  gywm: '关于我们',
  gy: '关于',
  lxwm: '联系我们',
  appxz: 'App 下载',
  callus: '订阅BIKING创世纪',
  zwzxxx: '掌握最新消息、见解和价格波动',
  zc: '注册',
  email: '邮箱地址',
  callingus: '联系我们',
  bqsy: '版权所有',
  tips: '温馨提示：投资有风险，入市需要谨慎'
}

const card = {
  title: '为什么我们是最友好的合约平台',
  text: 'BiKing助您创造、增值及保管财富',
  djxn: '返还手续费',
  jsqd: '手续费100%实时返还大幅度降低做单成本，提升盈利机会',
  zcbz: '极速出入金',
  cssbz: '极速出入金，出金入金顺畅无卡顿保证用户资金安全的同时，不错过每一个做单行情',
  gld: '便捷易用',
  zxhd: '完成注册&开仓仅需10秒，独有安全风控体系保护用户隐私，注册流程更简单',
  qthfw: '全天候服务',
  kffw: '舒适流畅的交互体验，金本位保证金机制24小时在线客服，交易问题实时解答',
  bjyy: '便捷易用',
  fxkk: '提供多种订单系统及交易工具，风险可控',
  axjy: '随时随地 · 安心交易',
  bkms: 'BiKing平台提供网页版，手机应用程式，API及FIX连接'
}

const news = {
  title: '新闻 & 视野',
  text: '了解世界顶级加密货币交易所的新闻动态及事业特点',
  sy: '视野',
  ltitle: '比特币能解决新兴市场的独特挑战',
  ldesc: '这篇文章最初看等于Cointelegraph.随着区块链经济伊斯坦堡峰会（Blockchain Economy Lstanbul Summit）聚焦新兴市场的发展，比特币的普及继续受到个案需求的驱动？…',
  more: '了解更多',
  xwfbs1: '新闻发布室',
  rdesc1: '数字资产交易所BiKng赞助区区块链经济伊斯坦堡峰会2022',
  xwfbs2: '新闻发布室',
  rdesc2: '数字资产交易所BiKng赞助区区块链经济伊斯坦堡峰会2022',
}

const info = {
  hzhb: '自动化交易平台合作伙伴',
  qsjy: '使用交易机器人在BiKing轻松交易',
  quadency: 'QUADENCY',
  clpt: '专业的自动交易策略平台',
  stacked: 'Stacked',
  glcf: '用户可使用Stacked投资加密指数。进行自动化交易及管理财富'
}
const menu = {
  creditCardOrder: '支付订单',
  ptmb: 'C2C',
    dsfjy: '第三方交易',
  kjmb: '快捷买币',
  xykmb: '信用卡买币',
  order: '订单',
  userOrder: '用户订单',
  merchantOrder: '商户订单',
  quickOrder: '快捷订单',
  merchant:'商家',
  asMerchant:'成为商家',
  advertisingManage: '广告管理',
  financialStatements: '财务报表',
  messageCenter: '消息中心',
  more: '更多',
  paymentSettings: '收款设置',
  publish: '发布广告',
  overview: '总览',
  aqzx: '安全中心',
  phsz: '偏好设置',
  hykhj: '合约狂欢季 交易新纪元',
  xszn: '新手指南',
  bwyjy: '币王研究院',
  bwsq: '币王社区',
  yhxz: '用户需知',
  bwysp: '币王衍生产品',
  jyxz: 'OTC交易须知'
}
const otc = {
  Realtimequotes:'实时报价仅供参考，请以第三方服务商页面价格为准',
  Realtimequotes1:'单笔限额',
  Realtimequotes2:'参考价',
  Realtimequotes3:'购买',
  Realtimequotes5:'请输入购买金额',
  Realtimequotes6:'最大',
  Realtimequotes7:'高于最大限额',
  Realtimequotes8:'数量',
  Realtimequotes9:'手续费用',
  Realtimequotes10:'支付方式',
  Realtimequotes11:'到账时间',
  Realtimequotes12:'支付成功后10~20分钟',
  Realtimequotes13:'确认购买',
  Realtimequotes14:'购买步骤',
  Realtimequotes15:'选择购买的数字货币、支付的法定货币和服务商',
  Realtimequotes16:'输入购买金额、在第三方服务商网站填写信息，并完成支付',
  Realtimequotes17:'在BiKing资产充值记录中查看购买的数字货币，在服务商网站查看订单详情',
  Realtimequotes18:'即将跳转至 {XXXXX} 进行购买',
  Realtimequotes24:'温馨提示',
  Realtimequotes19:'{XXXXX} 是由第三方独立运营的法币货币与加密货币交易平台所有相关服务均由{XXXXX}提供;',
  Realtimequotes20:'参考价是包含了平台手续费的价格，实际成交价格以{XXXXX}官网价格为准;',
  Realtimequotes21:'BiKing 对因使用该服务遭受的任何损失或损害不承担任何责任。',
  Realtimequotes22:'已知晓，立即前往',
  Realtimequotes23:'购买金额',
  Realtimequotes25:'第三方交易',
  Realtimequotes26:'请先去完善您的邮箱信息',
  Realtimequotes27:'现在完善',
  Realtimequotes28:'第三方商户名称',
  XXXXX:'{pay}是由第三方独立运营的法币货币与加密货币交易平台所有相关服务均由{pay}提供',
  XXXX:'参考价是包含了平台手续费的价格，实际成交价格以{pay}官网价格为准',
  ckj: '参考价（{price}）',
  meBuy: '我要买',
  服务商: '服务商',
  bjgq: '该报价已过期，请重新获取报价',
  gxbj: '更新报价',
  zxkdh: '最小可兑换 {min} {symbol}',
  zdkdh: '最大可兑换 {max} {symbol}',
  Available: '可用余额',
  Unknown: '未知',
  qxgz: '取消规则：买方当日累计200笔取消，将会限制当天的购买功能。',
  xncs: '向你出售',
  qxzzffs: '请选择支付方式',
  qdqx: '确定取消',
  wzxx: '我再想想',
  msk: '买家收款方式',
  zhmc: '账户名称',
  zhxq: '账户详情',
  xzhb: '选择货币',
  
  buyer: '买家',
  seller: '卖家',
  goSet: '去添加',
  addPayWayTitle: '添加收款方式',
  addPayWay: '你需要添加或激活至少一种收款方式，才能{type}数字货币',
  supportPayWay: '你需要添加并开启{type}支持的收款方式',
  top: '置顶',
  marginTips: '你已缴纳 {baseMarginPaid} USDT保证金，还需缴纳不低于 {needMargin} USDT',
  eyqx: '每日取消申诉3次将会限制发起申诉，同时如果是恶意取消，经查明将会冻结账户，请谨慎操作！',
  qdbzgm: '确定不再购买吗？',
  qxbtk: '取消订单后不会退款，如您已付款，请勿取消订单。',
  yzjbzj: '普通商家已追加保证金',
  xbjjcbzj: '需补缴基础保证金',
  jg: '价格',
  zxjgxd: '以当前最新价格下单',
  je: '金额',

  ccxe: '超出限额',
  yebz: '余额不足',
  qxsm: '请先实名',

  dfb: '待放币',
  jywc: '交易完成',
  buy: '购买',
  sell: '出售',
  coin: '币种',
  allCoin: '所有币种',
  frenchCurrency: '法币',
  payWay: '支付方式',
  all: '所有',
  bankCard: '银行卡',
  zfb: '支付宝',
  wx: '微信',
  search: '查询',
  merchant: '商家（30日完成单/30日完成率）',
  turnover: '成交量',
  completionRate: '%完成率',
  quotaOrNumber:'数量/限额',
  number: '数量',
  quota: '限额',
  price: '单价',
  paymentMethod: '收款方式',
  trade: '交易',
  handlingFee: '0手续费',
  buyUsdt: '买入USDT',
  sellBtc: '卖出USDT',
  theRemainingAmount: '剩余数量',
  userRealName: '用户实名',
  businessMessage: '商家留言',
  wantPay: '我要支付',
  wantSell: '我要出售',
  receive: '我将收到',
  password: '密码',
  pleaseEnterPassword: '请输入密码',
  cancel: '取消',
  buyUSDT: '购买USDT',
  sellUSDT: '出售USDT',
  Paymentchannel :'支付渠道（请参照服务提供方汇率为准。）',
  lumpSum: '总金额',
  agree: '如果你同意和币王进行C2C交易，即表示你接受',
  mzsm: '币王C2C交易法律免责声明',
  quit: '退出',
  confirm: '确定',
  orderDetail: '订单详情',
  limitExceeded: '超出限额',
  quantityRemaining: '剩余数量不足',

  cryptoTitle: '只需几步即可轻松购买USDT',
  cryptoSubTitle: '全球安全领先的数字资产 合约交易平台',
  availableBalance: '可用余额',
  sellAll: '全部出售',
  fundsTransfer: '资金划转',
  threeStep: '买币仅需三步',
  advantage: '选择币王买卖加密货币的优势',
  commonQuestion: '常见问题',
  otc_title: '使用C2C 0费率买/卖加密货币',
  otc_title1: '在BiKing上安全轻松地进行零手续费交易。立即透过银行转帐、信用卡等多种支付方式交易USDT',
  commonQuestion1: '什么是加密货币 C2C 交易？',
  commonQuestion2: 'C2C 交易的成本有多少？',
  commonQuestion3: '什么是 币王 C2C 上的商家？',
  commonQuestion4: '币王 C2C商家有盈利吗？',
  commonQuestion5: '怎么避免 C2C 诈欺？',
  commonQuestion1_desc: '加密 C2C 是指点对点加密货币交易，您可以直接相互交易加密货币，而不需要像中心化交易所那样的中介。',
  commonQuestion2_desc: 'C2C 交易的成本可能会因平台、特定加密货币以及交易时的网路拥塞情况而有很大差异。然而，币王 C2C对加密货币交易收取零费用，无需中介。',
  commonQuestion3_desc: '币王 C2C 上的商家是经过认证的用户，可以在平台上发布交易广告并与其他用户进行交易。',
  commonQuestion4_desc: '币王 C2C 商家的获利能力取决于多种因素，包括商家的交易策略、交易频率、买卖价差以及整体市场状况。',
  commonQuestion5_desc: '为了防范 C2C 诈骗，请验证对方的身份、使用安全平台、限制个人或财务数据的共享以及使用可追踪的支付方式。',
  register: '注册',
  registerByPhone: '邮箱或手机号码注册',
  authentication: '身份认证',
  authenticationId: '完成身份认证，只需ID证件',
  buyCoins: '买币',
  buyCoinsByCard: '信用卡/借记卡或银行转账买币',
  fast: '快速方便',
  easyUse: '买币操作简单',
  fastPayment: '只需要几分钟即可快速到账。',
  multiplePayment: '多种支付方式',
  platformSupports:'平台支持多种支付方式',
  flexibleConvenient: '为用户提供了更大的灵活性和方便性。',
  safeReliable: '安全可靠',
  measure: '采用多重安全技术和措施',
  informationSecurity: '确保资金安全，用户信息安全。',
  questionTitle1: '1.币王交易所介绍',
  questionSubTitle1: '币王交易所是一家全球领先的新加坡数字资产交易平台，持有美国/加拿大MSB双牌照，提供多种数字资产的交易、存储、管理等服务。',
  questionTitle2: '2.币王交易所提供哪些产品？',
  questionSubTitle2: '币王交易所提供以下几种产品：永续合约 ——优深度，秒撮合;现货交易 ——0手续，快速成交;跟单社区 ——资深交易员，稳定策略单;赠金交易 ——特有模式，福利不断;Web钱包 ——去中心化一站式服务',
  questionTitle3: '3.如何注册币王交易所？',
  questionSubTitle3: '您可以在币王交易所官网或币王APP进行注册。点击注册 ，完成注册流程即可使用币王交易所进行数字货币投资理财。',
  questionTitle4: '4.如何通过币王交易所购买数字货币？',
  questionSubTitle4: '币王交易所快捷买币支持多种支付方式与多种法币，为全球用户提供了更多的选择和便利，无论用户来自哪个国家或地区，都可以方便地使用本地货币购买数字货币。',
  questionTitle5: '5.如何进行数字资产交易？',
  questionSubTitle5: '您可以在币王交易所选择需要交易的数字资产，进入交易页面后，选择购买或出售，输入交易数量和价格，确认交易即可。并且币王交易所支持多种数字资产交易，包括比特币、以太坊、莱特币、瑞波币等。',
  questionTitle6: '6.币王交易所如何保障用户资产安全？',
  questionSubTitle6: '币王交易所采用多层加密技术保障用户信息和资产安全，并且采用冷热钱包分离的存储方式，确保用户资产安全。',
  
  orderType: '订单类型',
  orderStatus: '订单状态',
  to: '至',
  startTime: '开始日期',
  endTime: '结束日期',
  orderNo: '订单号',
  status: '状态',
  totalPrice: '总价',
  numberOrFee: '交易数量/手续费',
  tradingPartners: '交易对象',
  time: '时间',
  operate: '操作',
  details: '详情',
  noPay: '待付款',
  payed: '已付款',
  finish: '已完成',
  canceled: '已取消',
  complaint: '申诉中',
  legalCurrency: '法币金额',
  virtualCurrency: '数字货币',
  virtualCurrencyAddress: '收款地址',
  paymenttype: '支付类型',
  creatTime: '创建时间',
  success: '成功',
  pending: '处理中',
  awaiting: '待确认',
  declined: '失败',
  deposittokens:'卖单待用户存入代币',
  makepayment:'买单待用户付款',
  verification:'待校验用户身份',
  Transactioncancelled:'交易被取消',
  Transactionrejected:'交易被拒绝',
  mjskfs: '卖家收款方式',
  mjfkfs: '买家付款方式',
  toPay: '去支付',
  ddzdqx: '若你在{payTime}内还未选择付款方式,订单会自动取消',
  paying: '对方正在付款...',
  fkckh: '付款参考号：',
  dfwfkqx: '若对方在{payTime}内还未付款,订单会自动取消',
  ddqxwfck: '订单已取消，无法查看支付信息',
  ddqxckh: '订单已取消，付款参考号:',
  ssz: '申诉中，请等待， 付款参考号:',
  qxss: '取消申诉',
  xzfkfs: '您选择的付款方式',
  ddywc: '订单已完成',
  ss: '申诉',
  wcfqss: '* 订单完成1分钟后，才能发起申诉',
  bnfqss: '* 完成{time}小时后将不能再发起申诉',
  zxkf: '* OTC购买后，需要等待T+1天才可提现。如有疑问，请咨询客服。',
  sjyjn: '商家已缴纳{deposit} {depositName}保证金',
  wen1: '1.我什么时候能收到款？',
  da1: '对方完成付款后，您将会收到通知提示。',
  wen2: '2.买方下单后一直没有付款，如何处理？',
  da2: '卖方无法取消订单，但若等待时间过长，您可以发起申诉，客服团队将为您解决。',
  wen3: '3.未及时放行数字资产会造成什么影响？',
  da3: '收到款项后，若您未及时确认收款，可能会造成买方提起申诉，影响您在平台的信誉；同时，未处理之前您的资产也会一直冻结在您的平台钱包里。',
  wen4: '4.收款注意事项',
  da4: '1) 请反复确认是否真实收到对方款项，不要相信任何催促放币的理由，确认收到款项后再点击“确认收款”，避免造成数字资产的损失！<br/>2) 当买方的转款银行账户与平台账户的实名不一致时，请注意收款风险，如有疑问，请及时申诉。',
  qzgdsjnzf: '待支付，请于{payTime} 内向{associatedAdMerchantNickname}支付 {totalAmounts} {fiatCurrency}，付款参考号：',
  nxdfgm: '你向{associatedAdMerchantNickname}（{realName}）购买{amount_s} {coinsName}',
  dfxngm: '{userNickName}（{realName}）向你购买{amount_s} {coinsName}',
  nxdfcs: '你向{associatedAdMerchantNickname}（{realName}）出售{amount_s} {coinsName}',
  dfxncs: '{userNickName}（${realName}）向你出售{amount_s} {coinsName}',
  payed: '已支付',
  dddffx: '等待对方放行……',
  njhdq: '您将获得{quantity}{coinsName}',
  qxdd: '取消订单',
  kfqss: '付款后超{complaintPayed}分钟，如果对方仍未放币，可发起申诉',
  yfkfkckh: '对方已付款，付款参考号:',
  qjkqrsk: '请尽快确认收款',
  ddnsk: '等待你收款',
  zfje: '支付金额',
  skzh: '收款账号:',
  fkzhxm: '付款账户姓名:',
  qdskh: '* 请确保在自己的支付工具中收到款项后再进行确认',
  fbl: '放币',
  dfyqrfk: '* 对方已确认付款，若{complaintPayed}分钟后仍未能实收款项，方可发起申诉',
  jkcssk: '* 对方确认付款超24小时后，我方将不能再发起申诉，请尽快查实收款',
  qrfb: '确认放币',
  qwbqr: '请务必确认已收到当前订单的款项并确认金额无误后再进行放币',
  wyqrskzq: '我确认已收款并金额正确',
  tjssyy: '请提交申诉原因',
  srssyy: '请输入申诉原因',
  sctpxt: '上传图片（选填）',
  upload: '上传',
  zdscsz: '* 图片最多可上传三张，支持jpeg、jpg、png格式，请确保小于3Mb',
  sstj: '提 交',

  qrfk: '确认付款',
  fkje: '付款金额',
  sdzz: '*平台不支持自动扣款，请以本人的账号向以上账号自行转账，转账完成后请务必点击付款。若转账后未点击付款按钮，造成的损失将自行承担',
  bzts: '*转账时请勿备注类似BTC、USDT、BiKing等信息，否则卖家可拒',
  wfk: '未付款',
  w: '我',
  srxxfs: '输入信息，回车键发送',
  dan: '单',
  bnch: '不能添加同一种类型的支付方式',
 sd:'闪兑',
 from:'支付',
 to:'得到',
 rate:'兑换比例',
 successful:'兑换成功',
 fees:'手续费',
 slippage:'滑点',
 standards:'手续费收取标准',
 transactionamount:'交易金额的 {num}',
 confirm:'确认兑换',
 records:'全部闪兑记录',
 tocurrency:'消耗币种',
 consumption:'消耗数量',
 Getcurrency:'获得币种',
 GetQuantity:'获得数量',
 ExchangeStatus:'兑换状态',
 Exchangetime:'兑换时间',
 Youwillconsume:'你将消耗',
 YouwillGET:'你将获得',
 Updatequote:'更新报价',
 Failed:'兑换失败',
 Consumption:'消耗渠道',
 Completed:'已完成',
 chaeckrecords:'查看全部闪兑记录》',
Converted:'您成功将 {aaa} 兑换为 {bbb}',
recommend:'推荐',
wcsj: "完成时间",
}
const otcMerchant = {
  bzj: '保证金',
  mmggs: '买卖广告数',
  bx: '不限',
  ggzed: '广告总额度',
  kzjgged: '可追加广告额度',
  zjbzjbs: '追加保证金倍数',
  tbzss: '同步展示10条',

  tjsjsqb: '提交商家申请表',
  wcgjkycrz: '完成高级KYC认证',
  ynlx: '审核表单后，OTC专员会第一时间与您联系',

  zbzl: '准备资料',
  kssh: '快速审核',
  
  h1: '智能交易',
  h2: '成为C2C交易行家',
  h3: '即将成为认证商家',
  sjqy: '商家权益',
  c2cjy: '除了C2C交易<span>0费率</span>，我们还为商家提供了更多丰富多彩的权益',
  fbq: '你的法币区',
  ptsj: '普通商家',
  xsqy: '成为认证商家，享受更多权益',
  wtd: '申请成功即可发布委托单',
  xjn: '需缴纳{deposit}保证金',
  ljsq: '立即申请',
  cwptsj: '你已成为普通商家',
  cwrzsj: '你已成为认证商家',
  rzsj: '认证商家',
  xrd: '享有交易市场最高信任度',
  nbyq: '仅限Biking内部邀请',
  rzbs: '更尊贵的商家认证标识',
  pmq: '获得优先排名权',
  kffw: '享有1对1客服服务',
  sjxy: 'OTC{level}协议',
  xsjc: '新手教程',
  jygz: '交易规则',
  close: '关闭',
  submited: '我已提交',
  submitSuccess: '提交成功',

  sqsj: '申请成为商家',
  fwxy: 'biking币王网商家服务协议',
  xyb: '币王网是一个专门供用户进行数字资产交易和提供相关服务的平台。为了本协议表述之方便，公司和该网站在本协议中合称使用“我们”或其他第一人称称呼。只要注册并登录该网站的自然人或其他主体均为本网站的用户，本协议表述之便利，以下使用“您”或其他第二人称。为了本协议表述之便利，我们和您在本协议中合称为“双方”，我们或您单称为“一方”。',
  ptsm: '平台申明：',
  p1: '1.本网站仅作为提供数字资产交易信息、就数字资产的交易提供磋商、交易的场所，本网站不参与任何实质的数字资产交易，故交易双方应自行谨慎判断确定相关数字资产及/或信息的真实性、合法性和有效性，并自行承担因此产生的责任与损失。',
  p2: '2.本网站的任何意见、消息、探讨、分析、价格、建议和其他资讯均是一般的市场评论，并不构成投资建议。我们不承担任何因依赖该资讯直接或间接而产生的损失，包括但不限于任何利润损失。',
  p3: '3.本网站的内容会随时更改并不作另行通知，我们已采取合理措施确保网站资讯的准确性，但并不能保证其准确性程度，亦不会承担任何因本网站上的资讯或因未能链结互联网、传送或接收任何通知和信息时的延误或失败而直接或间接产生的损失。',
  p4: '4.使用互联网形式的交易系统亦存有风险，包括但不限于软件，硬件和互联网链结的失败等。由于我们不能控制互联网的可靠性和可用性，我们不会对失真，延误和链结失败而承担任何责任。',
  p5: '5.禁止使用本网站从事洗钱、走私、商业贿赂等一切非法交易活动或违法行为，若发现任何涉嫌非法交易或违法行为，本站将采取各种可使用之手段，包括但不限于冻结账户，通知相关权力机关等，我们不承担由此产生的所有责任并保留向相关人士追究责任的权利。',
  p6: '6.禁止使用本网站进行恶意操纵市场、不正当交易等一切不道德交易活动，若发现此类事件，本网站将对所有恶意操纵价格、恶意影响交易系统等不道德的行为采取警告、限制交易、关停账户等预防性地保护措施，我们不承担由此产生的所有责任并保留向相关人士追究责任的权利。',
  p7: '您在同意币王网服务协议之时，即视为您已经同意平台声明的全部内容。本协议由您与币王网的经营者共同缔结，本协议具有完整的合同效力。',
  zcbzj: '第一条：资产保证金',
  p8: '1.在商家通过平台KYC与反洗钱审查后，本平台将要求商家在其平台账户中存入一定的保证金，以保障其在平台上的交易安全和顺畅。',
  p9: '2.保证金具体数额会在本平台上的商家的法币资产中展示，也会在交易过程中展示给用户。',
  p10: '3.如出现以下情形时，本平台有权对商家的保证金进行扣押等处置，其保证金会被扣押≥1个月，确定对平台和用户造成损失的，后续会按照比例扣除保证金。',
  p11: '1)商家在交易过程中发生纠纷，且商家被判定应承担责任并履行相应义务，而商家不予配合的；',
  p12: '2)商家与本平台上未实名的账号进行交易的；',
  p13: '3)商家利用本平台从事任何非法行为的；',
  p14: '4)商家违反本协议或本网站上的任何法律文件规定或交易规则的；',
  p15: '5)商家涉嫌引导用户去其他平台交易；',
  p16: '6)商家涉嫌引导用户虚假注册，骗取平台新用户推广奖励；',
  p17: '7)商家涉嫌劝诫本平台合作伙伴的用户转至其他平台交易。',
  cxzg: '第二条：撤销商家资格',
  p18: '如果出现下列情形的，本平台有权单方解除您的商家资格：',
  p19: '1.交易中多次被本平台用户投诉的；',
  p20: '2.提交的申请材料中存在任何虚假信息的；',
  p21: '3.交易中出现欺诈等不诚信行为的；',
  p22: '4.不配合本平台客服处理订单或故意拖延客服处理订单的；',
  p23: '5.恶意利用本平台规则牟利的；',
  p24: '6.违反法律法规、本协议、或本网站法律文件或交易规则规定的；',
  p25: '7.存在本平台认定的不符合公序良俗、公平交易的行为；',
  p26: '8.其他违反法律法规的行为。',
  zlbh: '第三条：商家资料保护',
  p27: '1.商家资料的管理：您在申请成为商家时提交给本网站的认证资料（包括之前的实名认证材料），将不可撤销地授权由本网站保留。本网站承诺除法定或约定的事由外，不公开、编辑或透露您的认证资料，且不将保存在本网站的非公开内容用于商业目的，但以下情形除外： 您授权本网站透露的相关信息；',
  p28: '2.本网站向国家司法及行政机关提供；',
  p29: '3.本网站向本网站关联企业提供；',
  p30: '4.第三方和本网站一起为用户提供服务时，该第三方向您提供服务所需的相关信息；',
  p31: '5.基于解决您与第三方民事纠纷的需要，本网站有权向该第三方提供您的身份信息。',
  sjcn: '第四条：商家承诺',
  p32: '1.接受本协议全部条款是您申请认证的先决条件。',
  p33: '2.您声明并保证，您不得为任何非法或为本协议所禁止之目的进行认证申请。',
  p34: '3.您不得以任何可能损害、使瘫痪、使过度负荷或损害其他网站或其他网站的服务或本网站或干扰他人对于商家申请的使用等方式使用申请服务。',
  p35: '4.您不得未经本网站许可提供的任何方式取得或试图取得任何资料或信息。',
  p36: '5.您确认并承诺：您进行使用本网站进行交易并非出于违反法律法规或破坏本网站数字资产交易秩序的目的。',
  p37: '6.商家承诺遵守平台对进行数字资产交易的所有信息披露工作要求，按照平台要求如实提供文件、资料或信息。如商家拒绝提供平台所要求的文件、资料或信息，则乙方有权视情况做出撤销商家资格的决定。',
  ptmz: '第五条：平台免责',
  bcfx: '以下情形，本平台不承担任何责任：',
  p38: '1.由于您将账户密码告知他人或未保管好自己的密码或与他人共享账户或任何其他非本网站的过错，导致您的个人资料泄露的；',
  p39: '2.任何由于黑客攻击、计算机病毒侵入或发作、电信部门技术调整导致之影响、因政府管制而造成的暂时性关闭、由于第三方原因(包括不可抗力，例如国际出口的主干线路及国际出口电信提供商一方出现故障、火灾、水灾、雷击、地震、洪水、台风、龙卷风、火山爆发、瘟疫和传染病流行、罢工、战争或暴力行为或类似事件等)及其他非因本网站过错而造成的认证信息泄露、丢失、被盗用或被篡改等；',
  p40: '3.由于与本网站链接的其它网站（如网上银行等）所造成的银行账户信息泄露及由此而导致的任何法律争议和后果；',
  p41: '4.任何因用户向本网站提供错误、不完整、不实信息等造成不能通过认证或遭受任何其他损失，概与本网站无关；',
  p42: '5.因非本平台之原因，您的资产被他人欺诈的。',
  ptts: '第六条：平台提示',
  p43: '1.为实现身份信息审查，本网站上可能包含指向第三方网站（如网上银行网站）的链接（以下简称“链接网站”）。 “链接网站”非由本网站控制，对于任何“链接网站”的内容，包含但不限于“链接网站”内含的任何链接，或“链接 网站”的任何改变或更新，本网站均不予负责。自“链接网站”接收的网络传播或其它形式之传送，本网站不予负责。',
  p44: '2.本平台只为您通过本网站进行数字资产交易活动（包括但不限于数字资产交易等服务）提供网络交易平台服务，本网站并不作为买家或卖家参与买卖数字资产行为本身；本网站不提供任何国家法定货币充入和提取的相关服务。',
  p45: '3.您一旦登录本网站、使用本网站的任何服务或任何其他类似行为即表示您已了解并完全同意本协议各项内容，包括本网站对本协议随时所做的任何修改。',
  p46: '4.您在使用本网站过程中点击任何标有“同意”或类似意思的按钮的行为或以其他本网站允许的方式实际使用本网站提供的服务时，均表示您完全了解、同意且接受本协议项下的全部条款的约束，无您手写的书面签字就本协议对您的法律约束力无任何影响。',
  p47: '5.我们保留不时修订本协议、并以网站公示的方式进行公告、不再单独通知您的权利，变更后的协议会在本协议首页标注变更时间，一经在网站公布，立即自动生效。',
  tyxy: '我同意该协议内容',
  nextStep: '下一步'
}
const user = {
  txxz: '修改资金密码24小时不可提现',
  name: '昵称',
  rzdj: '身份认证等级',
  phone: '手机',
  email: '邮箱',
  zzc: '资产估值',
  hours24: '24小时',
  market: '市场行情',
  notice: '公告',
  more: '更多>>',
  cb: '充币',
  tb: '提币',
  hz: '划转',
  wsm: '未实名',
  cjrz: '初级认证',
  gjrz: '高级认证',
  qwgjrz: "前往高级认证",
  aqszx: '已完成安全设置项',
  xgaqszx: '修改您的安全设置项',
  dlmm: '登录密码',
  zjdl: '通过设置登录密码，您将可以使用账号和登录密码直接登陆',
  ghmm: '更换密码',
  sz: '设置',
  jymm: '交易密码',
  yzjymm: '账户资金变动时，需先验证交易密码。',
  ghjymm: '更换交易密码',
  sjyz: '手机验证',
  yzdx: '用于登录、提现、修改密码、安全设置时收取验证短信',
  xgsj: '修改手机号',
  zwbd: '暂未绑定',
  ggyz: '谷歌验证',
  syzn: '使用指南',
  bd: '绑定',
  yxyz: '邮箱验证',
  tbqr: '您可以绑定一个常用邮箱、用于登录、找回密码、提币时的确认',
  bdyx: '绑定邮箱',
  xgyx: "修改邮箱",
  xyx: "新邮箱",
  dljl: '最近十条登录记录',
  zjdljl: '这是您最近的10条登录历史',
  dlsj: '最近登录时间',
  ip: 'IP地址',
  aqsz: '安全设置',
  yhdl: '用户登录',
  xgbdsj: '修改绑定手机',
  bdsj: '绑定手机',
  dxyzm: '短信验证码',
  second: '秒',
  fsyzm: '发送验证码',
  xsjh: '新手机号码',
  ggyzm: '谷歌验证码',
  yxyzm: '邮箱验证码',
  confirm: '确 定',
  edit: '修改',
  name: '姓名',
  srxm: '请输入姓名',
  zjlx: '证件类型',
  xzzjlx: '请选择证件类型',
  zjhm: '证件号码',
  srzjhm: '请输入证件号码',
  zcsr: '请再次输入密码',
  mmbyz: '两次输入密码不一致!',
  sfz: '身份证',
  jgz: '军官证',
  hz: '护照',
  jmtxz: '台湾省居民通行证',
  gatxz: '港澳居民通行证',
  hwid: '海外ID',
  srdx: '请输入短信验证码',
  sryx: '请输入邮箱验证码',
  srgg: '请输入谷歌验证码',
  jdlmm: '旧登录密码',
  xdlmm: '新登录密码',
  qrxmm: '确认新密码',
  qrdlmm: '确认登录密码',
  jjymm: '旧交易密码',
  xjymm: '新交易密码',
  qrjymm: '确认交易密码',
  qwcyz: '请完成验证',
  smrz: '请先进行实名认证',
  sryzm: '请输入验证码',
  srsjh: '请输入手机号',
  xgdlmm: '修改登录密码',
  szdlmm: '设置登录密码',
  xgjymm: '修改交易密码',
  szjymm: '设置交易密码',
  czmm: '重置密码',
  
  bdgg: '绑定谷歌验证器',
  lbyzq: '请下载谷歌两步验证器',
  smewm: '使用谷歌两步验证器扫码二维码',
  srdm: '如果二维码无法识别，请手动输入下列代码',
  copy: '复制',
  copySuccess: '复制成功',
  sryx: '请输入邮箱',
  srzqyx: '请输入正确的邮箱地址',
  srsjyzm: '请输入手机验证码',
  sryxyzm: '请输入邮箱验证码',
  srggyzm: '请输入谷歌验证码',
  passwordTypeError: '密码格式错误，密码必须是8-32位，同时包含大小写字母和数字。',
  passwordDiff: '两次密码不一致',
  zcsrxmm: '请再次输入密码',
  language: '语言',
  bdhb: '本地货币',
  wdbph: '稳定币偏好',
  
  相关问题:"相关问题",
  为什要进行身份认证:"为什要进行身份认证",
  上传中:"上传中……",
  开始上传:"开始上传",
  录制第一段视频:"录制第一段视频",
  录制第二段视频:"录制第二段视频",
  录制完成:"录制完成",
  请手持身份证正面:"请手持身份证正面，将其放置于面部下方",
  正对摄像头:"正对摄像头，保持5秒以上",
  摘下眼镜:"摘下眼镜，帽子等遮挡物",
  请按视频文字提示录制视频:"请按视频文字提示录制视频",
  开始录制:"开始录制",
  第一段视频:"第一段视频",
  第二段视频:"第二段视频",
  录制一段视频:"录制一段视频",
  点击开始录制:"点击开始录制",
  视频录像认证:"视频录像认证",
  身份证号:"身份证号",
  证件验证:"证件验证（照片/扫描件）",
  zjyz: "证件验证",
  请确保图片格式为:"请确保图片格式为jpg/jpeg/png 请确保图片尺寸小于2mb",
  请手持证件照:"请手持证件照和个人签名，个人签名需要包括Biking+当天日期",
  当日签名照:"手持证件照+当日签名照",
  上传证件签名页:"上传证件签名页",
  请保证所有信息清晰:"请保证所有信息清晰",
  上传证件页信息:"上传证件页信息",
  请选择国家:"请选择国家",
  请上传正面证件照:"请上传正面证件照",
  请上传反面证件照:"请上传反面证件照",
  手持证件照:"手持证件照",
  请选择区域:"请选择区域",
  认证要求: "认证要求",
  证件信息: "证件信息",
  人脸识别: "人脸识别",
  立即认证: "立即认证",
  认证要求: "认证要求",
  什么是加密货币P2P交易: "什么是加密货币P2P交易",
  最好的P2P加密货币交易所是什么: "最好的P2P加密货币交易所是什么？",
  P2P交易的成本有多少: "P2P交易的成本有多少？",
  什么是BikingP2P上的商家: "什么是Biking P2P上的商家？",
  我们正在审核您的申请: "我们正在审核您的申请",
  预计审核时间: "预计审核时间：72小时",
  驳回: "驳回",
  未提交: "未提交",
  手续费等级: "手续费等级",
  去认证: "去认证",
  已认证: "已认证",
  开通更多权限: "认证身份，开通更多权限",
  在别人贪婪时要保持警惕:"在别人贪婪时要保持警惕，而在别人警惕时就要贪婪——巴菲特",
  kyc声明: '我是{Name}，证件号码是：{No}。我自愿在Biking注册和交易，并保证账户是本人使用，我保证所有的资产来源合法，已经了解并能承受全部交易风险，提取的数字资产不做非法使用，也不会用本平台进行任何非法活动，例如洗钱、传销和非法兑换外币等。',
  编辑头像:"编辑头像",
  请选择一个头像用作您个人资料的照片:"请选择一个头像用作您个人资料的照片",
  中国:"中国",
  其他:"其他" ,
  questionTitle1: '1.为什么需要提供实名认证？',
  questionSubTitle1: '币王采用全球合规化身份验证服务，保障所有用户的资金安全。因此，在填写信息时，请务必提供符合要求的材料。',
  questionTitle2: '2.完成身份认证有什么好处？',
  questionSubTitle2: '所有用户均须完成实名认证，方可访问币王的OTC功能。尚未完成实名认证的用户，不影响链上充值提现。',
  questionTitle3: '3. 如何更新身份认证？',
  questionSubTitle3: '若您的身份信息发生更改且符合以下条件时，您可以联系在线客服提交申请更新身份认证理由：',
  questionTitle4: '4. KYC认证需要多长时间？',
  questionSubTitle4: '您提交的信息通常会在5分钟内得到审核。 但是，如遇特殊情况可能需要更长的时间。',
  questionTitle5: '5. 币王身份认证安全吗？',
  questionSubTitle5: '币王身份认证是安全的，它帮助我们为您和其他所有用户打造安全的平台。 您的文件对我们也是保密的。',
  questionTitles:'1. 证件已过期；',
  questionTitles1:'2. 证件上的姓名已更改；',
  questionTitles2:'3. 证件上的身分证号码已变更；',
  questionTitles3:'4. 国籍已变更；',
  questionTitles4:'5. 更新证件，以确保正常使用法币；',
  questionTitles5:'6. 更改为系统语言识别的姓名（例如：从本国身份证改为护照）；',
  Z1001: "系统错误",
  Z1003: "验证中断",
  Z2002: "网络错误",
  Z2003: "客户端设备时间错误",
  Z2006: "认证失败",
  Z5050: "人脸验证成功",
  Z5051: "上传刷脸图片失败",
  Z5052: "数据错误或程序异常。",
  Z5053: "网络错误。",
  Z5054: "摄像头无权限或无法获取摄像头数据。",
  Z5055: "用户退出。",
  Z5056: "重试次数过多。",
  Z5057: "视频上传超时。",
  Z5058: "视频格式不满足要求。",
  Z5059: "视频中无有效人脸。",
  Z5128: "验证不是同一个人。",
  法币充值:'法币充值&提现限额',
  无限额:'无限额',
  数字货币充值:'数字货币充值',
  数字货币提现限额:'数字货币提现限额',
  C2C交易限额:'C2C交易限额',
  "参数不合法": '参数不合法',
  h5smrz: "实名认证",
  bhzhan: "设置密码，保护您账户安全",
  jxsmrz: "进行实名认证，保证用户资金安全",
  qwrz: "前往认证",
  dgzhzd: "1.单个账号，每日最多提交5次",
  rhzp: "2.您提交的任何照片、视频或文档详细资料都不会被储存或以任何方式使用",
  sfzm: "身份证明",
  zjqfg: "证件签发国家",
  dw: "定位",
  sfxx: "身份信息",
  dqdw: "当前定位",
  gjdq: "国家/地区",

}

const h5 = {
  chart: '图表',
  mmp: '买卖盘',
  sscj: '实时成交',
  wt: '委托',
  lswt: '历史委托',
  zj: '资金',
  sj: '市价',
  ky: '可用',
  zczh: '资产折合',
  dj: '冻结',
  zwsj: '暂无数据',
  zx: '自选',
  buysell: '买入/卖出'
}

const worldCup = {
  common: {
    cancel: '取消',
    confirm: '确认',
    iKnow: '我知道了',
    points: '积分',
    day: '天',
    hour: '小时',
    minute: '分',
    second: '秒',
    noData: '暂无数据',
    noMatch: '暂无比赛',
    businessClosed: '业务已关闭',
    loadFailed: '加载失败，请稍后重试',
  },
  index: {
    liveFeed: '实时动态',
    heroTitle: '竞猜世界杯',
    heroSplit: '瓜分',
    heroPrizePool: '奖池',
    heroMillionPrizePool: '瓜分百万奖池',
    heroSub: '更有Tesla和世界杯门票等你来拿',
    heroJoinedPrefix: '已有',
    heroJoinedSuffix: '人参与，奖池持续增长中',
    activityTimeLabel: '活动时间：',
    refreshing: '刷新中...',
    releaseToRefresh: '松开立即刷新',
    pullToRefresh: '下拉刷新',
    livePrizePool: '实时奖池',
    growing: '实时增长中',
    userPoolRatioLabel: '个人用户可瓜分奖池：',
    teamPoolRatioLabel: '团队可瓜分奖池：',
    poolCountdownLabel: '距离瓜分第{phase}阶段奖池倒计时',
    poolCountdownFinalLabel: '距离瓜分最终阶段奖池倒计时',
    poolActivityStartCountdownLabel: '距离活动开始',
    poolSplitDoneBadge: '奖池已完成瓜分',
    totalAllocatedPoolLabel: '总瓜分奖池',
    poolAllocateFirst: '第一次瓜分',
    poolAllocateSecond: '第二次瓜分',
    poolAllocateThird: '第三次瓜分',
    poolAllocateFinal: '最终瓜分',
    poolTeamPrefix: '战队：',
    poolPersonalPrefix: '个人：',
    poolPersonalCount: '个人：{n}人',
    teamTitle: '组建战队，收益翻倍',
    teamSubPrefix: '加入战队，有机会提升',
    teamSubSuffix: '收益',
    teamAgentTitle: '代理战队',
    teamAgentDesc: '平台代理可一键组建战队，<span class="wc-hl">团队成员积分将汇总为团队总积分</span>，同时完成团队任务可获得团队<span class="wc-hl">额外加分</span>，团队积分越高，<span class="wc-hl">瓜分奖池</span>机会会越大。',
    createTeamNow: '立即组建战队',
    applyAgentNow: '我不是代理，立即申请',
    teamUserTitle: '自由战队',
    teamUserDesc: '无需成为代理，可加入自由战队，与其他自由用户组建团队，共同参与<span class="wc-hl2">团队积分</span>，获得<span class="wc-hl2">奖池瓜分</span>机会。',
    joinNow: '立即加入',
    championTitle: '冠军预测',
    championSub: '每个用户只可预测一次，锁定后不可更改，猜中获得个人瓜分奖池的资格',
    championHintPrefix: '预测正确冠军的用户可获得奖池',
    championHintSuffix: '的瓜分资格',
    championPoolShare: '的瓜分资格',
    championWin: '恭喜您猜中冠军',
    championLose: '很遗憾，您未猜中',
    championWinSub: '获得瓜分个人奖池的名额',
    championNoParticipation: '活动结束，您未参与竞猜',
    confirmPredict: '确认预测',
    predictCountdown: '预测倒计时',
    predictEnded: '预测已结束',
    notice1: '用户 p***12 刚完成竞猜，赢得 500 积分',
    notice2: '用户 k***88 刚兑换 Tesla 一辆',
    notice3: '用户 a***23 刚完成竞猜，赢得 1200 积分',
    notice4: '用户 x***56 邀请好友获得 100 积分',
    notice5: '用户 m***07 刚兑换世界杯门票 1 张',
    tabPredict: '竞猜',
    tabTask: '任务',
    tabRank: '排行',
    tabExchange: '兑换',
    tabMine: '我的',
    tabRules: '规则',
  },
  toast: {
    refreshSuccess: '刷新成功',
    predictSuccess: '竞猜成功，已提交结果',
    inviteJumping: '跳转邀请页面...',
    applyAgentPending: '代理申请功能开发中，敬请期待！',
    championLocked: '冠军预测已锁定！',
    exchangeSubmitted: '兑换申请提交成功，等待平台客服联系您进行奖品发放。',
    pointsNotEnough: '积分不足',
    createTeamSubmitted: '战队创建成功',
    joinedFreeTeam: '已加入自由战队',
  },
  section: {
    predictTitle: '赛事竞猜',
    predictSub: '预测比赛结果，猜对+{correctPoints}积分，猜错+{wrongPoints}积分',
    predictRules: '竞猜说明',
    taskTitle: '完成任务赚积分',
    taskSub: '多种任务，多重奖励，加速积累收益',
    exchangeTitle: '积分兑换商城',
    exchangeSub: '丰富奖品，先到先得',
    exchangeRules: '兑换说明',
    rankTitle: '实时排行榜',
    rankSub: '比拼实力，冲击榜首',
    rulesTitle: '活动规则',
    rulesSub: '透明公开，公平公正',
  },
  dialog: {
    taskTitle: '任务说明',
    taskReward: '完成后可获得',
    predictConfirmTitle: '赛事竞猜',
    predictConfirmHint: '你猜哪只队伍会获胜？',
    predictPay: '支付',
    predictPayTip: '从资金账户扣除，请确保余额充足',
    predictConfirmBtn: '确认竞猜',
    predictSuccessTitle: '竞猜成功',
    predictSuccessDesc: '已成功提交竞猜结果，可在“我的竞猜”中查看记录。',
    exchangeTitle: '商品兑换',
    exchangeNeedPoints: '所需积分',
    exchangeBalance: '余额：',
    exchangeContactTitle: '至少填写一种联系方式',
    exchangeTipTitle: '温馨提示',
    exchangeTip1: '请至少填写一种联系方式，提交后平台客服会联系您进行奖品发放的沟通。',
    exchangeTip2: '如果长时间与您未联系，请主动联系客服进行处理。',
    exchangeConfirm: '确认兑换',
    teamJoinTitle: '加入团队',
    teamCreateDesc: '确认组建战队？',
    teamJoinFreeDesc: '您确认加入自由战队？',
    teamJoinTipTitle: '温馨提示',
    teamJoinTipDesc: '您是属于代理团队成员，不能加入自由战队，您可邀请您的邀请者（代理人）一起组队参加团队对战。',
    applyAgentContactTitle: '重要提示',
    applyAgentContactPrefix: '请添加 Telegram：',
    applyAgentContactSuffix: '以申请成为代理。成为代理后，即可创建战队。',
    applyAgentContactBtn: '知道了',
  },
  rank: {
    teamRank: '战队排行',
    personRank: '个人排行',
    yourTeamRank: '你的战队排名',
    yourPersonRank: '你的个人排名',
    captain: '队长：',
    currentPoints: '当前积分',
    members: '成员',
    teamDetail: '团队详情',
    noRankYet: '暂无排行',
  },
  mine: {
    myPoints: '我的积分',
    totalPoints: '总积分',
    myPredict: '我的竞猜',
    myExchange: '我的兑换',
    myBonus: '我的奖金',
    totalBonus: '我获得的总奖金',
    bonusPhase: '瓜分阶段：',
    bonusPhaseFirst: '第一阶段',
    bonusPhaseSecond: '第二阶段',
    bonusPhaseThird: '第三阶段',
    bonusPhaseFinal: '最终阶段',
    bonusTypeTeam: '团队瓜分',
    bonusTypePersonal: '个人瓜分',
    bonusPoints: '瓜分时积分：',
    bonusType: '类型：',
    bonusAmount: '奖金：',
    totalCount: '共 {total} 条',
    myTeam: '我的战队',
    selectTeam: '选择队伍',
    predictMatch: '比赛',
    winTeam: '获胜队伍',
    predictResult: '竞猜结果',
    hit: '猜中',
    miss: '未猜中',
    draw: '平局',
    exchangeItem: '兑换物品',
    contactInfo: '联系方式',
    exchangeStatus: '兑换状态',
    currentRank: '当前排名',
    notJoinedTeam: '未加入战队',
    memberContribution: '团员贡献',
    teamTaskContribution: '团队任务贡献',
    loading: '加载中...',
    statusDone: '已完成',
    statusPending: '处理中',
    statusFail: '兑换失败',
    logCompleteKyc: '完成KYC',
    logExchangePrize: '奖品兑换',
    logMatchPredict: '赛事竞猜',
    logDailySign: '每日签到',
    logFinishTask: '完成任务',
    taskFirstRecharge: '完成首次充值 >= {amount} USDT',
    pagerTotal: '共 {total} 条',
    prevPage: '上一页',
    nextPage: '下一页',
    goTo: '前往',
    page: '页',
  },
  mobile: {
    title: '世界杯竞猜',
  },
  nav: {
    entry: '世界杯竞猜',
  },
  mock: {
    korea: '韩国',
    germany: '德国',
    china: '中国',
    uk: '英国',
    france: '法国',
    portugal: '葡萄牙',
    senegal: '塞内加尔',
    brazil: '巴西',
    india: '印度',
    turkiye: '土耳其',
    usa: '美国',
    jerseyPack: '官方球衣套装',
    vipCard: 'VIP 加密会员卡',
    jerseyKeyword: '球衣',
  },
  predict: {
    round: {
      group: '小组赛',
      r32: '32强赛',
      r16: '16强赛',
      quarter: '1/4决赛',
      semi: '半决赛',
      third: '季军赛',
      final: '决赛',
    },
    status: {
      joined: '已参与',
      open: '开放竞猜',
      ongoing: '比赛中',
      ended: '已结束',
    },
    btn: {
      joined: '已竞猜',
      open: '{betPaymentAmount}USDT 立即竞猜',
      ongoing: '比赛进行中',
      ended: '竞猜已结束',
    },
    joinedMatchPhase: {
      pending: '未开始',
      ongoing: '进行中',
      ended: '已结束',
    },
    joinedResult: {
      hit: '猜中 +{points}',
      missPrefix: '猜错',
      missSuffix: '+{points}',
    },
  },
  rules: {
    fundSource: '资金来源',
    poolSplit: '奖池瓜分',
    teamIntro: '战队说明',
    poolRulesTitle: '奖池说明',
    teamRulesTitle: '战队说明',
    predictRulesTitle: '竞猜说明',
    exchangeRulesTitle: '兑换说明',
  },
  rulesText: {
    poolDesc1: '活动初始奖金 {initialFunds} USDT，活动有效时间内，部分业务奖金按照比例投入奖池，不断提高奖池总额',
    poolLine1: '每笔充值金额的 {rechargePercentageToPool}% 自动进入奖池；',
    poolLine2: '每笔永续合约交易手续费的 {contractFeePercentageToPool}% 自动进入奖池；',
    poolLine3: '每完成一位有效邀请用户，奖池自动增加 {additionalAmountPerValidUser} USDT。',
    poolLine4: '*低于 0.01 USDT 将不会计入奖池。',
    teamPoolTitle: '团队瓜分奖池',
    teamPoolRuleTitle: '团队瓜分规则',
    teamPoolRule1: '团队获得奖金后，队长（自由战队除外）获得瓜分奖金的20%，队长奖金 = 总奖池 * 该次瓜分比例 * 20%',
    teamPoolRule2: '获得瓜分资格的团队成员根据个人积分贡献权重分配奖金，队员瓜分金额 = [(总奖池 * 该次团队瓜分比例) * (1 - 0.2) / 具备瓜分资格的团队成员积分之和] * 个人总积分',
    userPoolTitle: '个人用户瓜分奖池规则',
    poolSplit1: '第一次：8 强队伍确定后，积分排名第一名团队瓜分 {percentage}% 奖池，余额继续累积',
    poolSplit2: '第二次：4 强队伍确定后，积分排名第一名团队瓜分 {percentage}% 奖池，余额继续累积',
    poolSplit3: '第三次：半决赛结束后，积分排名第一名团队瓜分 {percentage}% 奖池，余额继续累积',
    poolSplit4: '最终：决赛结束后，积分排名第一名团队瓜分 全部奖池的 {percentage}%，瓜分结束后，团队成员的可用积分清零',
    userPoolLine1: '比赛结束，猜中冠军比赛的用户获得个人瓜分奖池的资格',
    userPoolLine2: '所有猜中冠军的用户根据个人总积分瓜分奖池的 {percentage}%，瓜分结束后，个人可用积分清零',
    poolFormula: '*例如，某团队获得瓜分资格的用户有 N 个，每个人的积分依次以 N1、N2、N3...Nn表示，瓜分时的总奖池金额为A，该次瓜分奖池的比例是 20%，队长奖励比例 20%，则团队成员获得奖金 = [(A*20%)(1-0.2)/(N1+N2+N3+...+Nn)]*个人总积分',
    teamRule1: '1.只有一级代理可以发起组队，如果不是代理，可申请成为代理之后组建战队',
    teamRule2: '2.如果既不是代理，也无法获得代理资格，则可以加入平台设定的自由战队（不属于代理的用户）',
    teamRule3: '3.代理组建战队后，与其团队成员自动成为一个战队',
    teamRule4: '4.团队总积分=战队成员积分总和+团队任务奖励积分',
    teamRule5: '5.团队成员瓜分奖池的资格要求：活动期间参与竞猜≥{quizTimesThreshold}次 + 永续合约交易量≥{poolContractThreshold}U',
    predictRule1: '1.比赛开始后将会关闭竞猜',
    predictRule2: '2.每场比赛每个用户仅可参与竞猜 1 次',
    predictRule3: '3.竞猜需要支付 {betPaymentAmount} USDT',
    predictRule4: '4.猜对获胜队伍 +{correctBonusPoints} 积分，猜错 +{wrongBonusPoints} 积分',
    predictRule5: '5.如果对战（小组赛）是“平局”则 按照猜错计算积分，+{wrongBonusPoints} 积分',
    exchangeRule1: '1.奖品数量有限，兑完为止；先到先得',
    exchangeRule2: '2.奖品兑换后扣除相应的积分，你所在团队积分相应扣除',
    exchangeRule3: '3.兑换奖品时填写联系方式，平台工作人员会联系后续的奖品发放事宜',
    exchangeRule4: '4.兑换时填写的联系方式有误会造成兑换奖品受阻，请仔细确认和核对并持续关注消息',
    exchangeRule5: '5.如果长时间未收到平台联系，请主动联系平台客服处理',
    timeTitle: '活动时间',
    activePeriodLabel: '活动有效时间：',
    activePeriodValue: '{startTime} ~ {endTime}',
    activeTip: '活动开始后才计算和统计积分，奖池开始累积增加',
    predictPeriodLabel: '竞猜时间：',
    predictPeriodValue: '冠军竞猜：{startTime} ~ {endTime}',
    businessTitle: '业务规则',
    businessRule1: '1. 有效邀请用户：有效邀请指受邀请人充值≥{inviteRechargeThreshold}U，永续合约交易量≥{contractVolumeThreshold}U',
    businessRule2: '2. 团队成员瓜分奖池的资格要求：活动期间参与竞猜≥{quizTimesThreshold}次 + 永续合约交易量≥{poolContractThreshold}U',
    businessRule3: '3. 个人积分可随时进行礼品兑换，兑换后个人及团队相应积分扣除',
    businessRule4: '4. 实物奖品数量有限，兑完为止',
    businessRule5: '5. 世界杯门票兑换截止世界杯开幕前一日，因不可抗力因素导致无法兑换实物门票可兑换等值USDT',
    statementTitle: '严正声明',
    statement1: '1. 每位用户仅限使用一个账户参与活动，严禁使用多个账户（包括但不限于批量注册账户、关联账户等）参与活动，系统将对参与账户的登录设备及IP地址进行监测，若发现多个账户使用同一设备或同一IP地址进行操作，平台有权判定为关联账户；',
    statement2: '2. 用户参与活动的交易行为必须真实有效，严禁任何形式的对刷交易、对敲交易或自成交行为',
    statement3: '3. 平台将通过风控系统识别异常交易行为，包括但不限于：高频反向开平仓、同价位对冲交易、低风险套利刷量行为',
    statement4: '4. 一经发现异常交易行为，平台有权：清除该部分交易产生的积分、取消用户活动参与资格、冻结或回收相关奖励',
    statement5: '5. 奖池金额及奖励分配以平台最终统计结果为准，平台保留对本活动规则的最终解释权',
  },
  exchange: {
    needPoints: '所需积分',
    stock: '剩余库存',
    buyNow: '立即兑换',
    soldOut: '已售罄',
    badgeUnique: '全站唯一大奖',
    badgeOnlyCount: '仅{count}件',
    itemFinalTicket: '世界杯决赛门票',
    itemSignedFootball: '签名足球',
  },
  task: {
    earnPoints: '赚积分',
    goFinish: '去完成',
    goTeamTask: '做任务赚取团队积分',
  },
  taskGroup: {
    daily: '每日任务',
    invite: '邀请任务',
    recharge: '充值任务',
    teamTrade: '团队交易任务',
    dailyLimitPrefix: '每日奖励上限',
    teamLimitPrefix: '团队每日奖励上限',
    limitPoints: '{num} 积分',
    limitSuffix: '，每日00:00:00 (GMT+08:00) 刷新',
    rechargeLimitSuffix: '仅计算活动期间首次充值是否达标',
    inviteCta: '立即邀请赚积分',
    taskPredictOnce: '每参与一次赛事竞猜',
    taskTrade10000: '每累计完成永续合约交易量 {tradeVolume}U',
    taskInviteValidUser: '每完成一位有效用户邀请',
    taskInviteRegister: '邀请好友注册',
    taskInviteKyc: '邀请好友完成KYC',
    taskInviteRecharge: '邀请好友完成首次充值',
    taskFirstRecharge: '首次充值 >= {amount} USDT',
    taskTeamTrade10000: '每累计完成{tradeVolume} USDT永续合约交易额，团队+{teamBonusPoints}积分',
  },
};

export {
  apis,
  games,
  h5,
  trading,
  download,
  login,
  user,
  advertise,
  otcMerchant,
  otc,
  menu,
  time,
  state,
  text,
  seckillRes,
  header,
  hyy,
  index,
  indexPage,
  Verification,
  NAVS,
  FOOTERS,
  SIDEBAR,
  seckill,
  apply,
  recommend,
  market,
  banner,
  card,
  news,
  info,
  navCard,
  choice,
  plat,
  risk,
  license,
  footer,
  merchandiser,
  codeInfo,
  placeOrder,
  tableList,
  codelist,
  contractHyy,
  common,
  dialog,
  panKou,
  invite,
  property,
  contest,
  taskCenter,
  ieo,
  earn,
  tradingContest,
  agent,
  live,
  hongbao,
  worldCup
};



// WEBPACK FOOTER //
// ./src/i18n/lang/public/zh.js